const firebaseConfiguration = {
  apiKey: `${process.env.REACT_APP_FIREBASE_API_KEY}`,
  authDomain: "auth.engineer-cloud.jp",
  projectId: "engineer-cloud",
  storageBucket: "engineer-cloud.firebasestorage.app",
  messagingSenderId: "554858416911",
  appId: "1:554858416911:web:5b492d774ae612dc7dcc7a"
}

module.exports = {
    firebaseConfiguration: firebaseConfiguration
}